/* eslint-disable import/prefer-default-export */
import {
  axiosInstance,
  axiosDefault,
} from './apis/index';

export const getTrainingCenter = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/training-center/get', data, { params });
  return response.data;
};

export const getPlayers = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/training-center/getPlayers', data, { params });
  return response.data;
};

export const getTrainingCenterInfo = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/training-center/getInfo', data, { params });
  return response.data;
};

export const getTrainingCenterStart = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/training-center/start', data, { params });
  return response.data;
};

export const getTrainingCenterClaim = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/training-center/claim', data, { params });
  return response.data;
};

export const getTrainingCenterStop = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/training-center/stop', data, { params });
  return response.data;
};

export const checkDeposit = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/wallet/checkDeposit', data, { params });
  return response.data;
};

export const getTeamInfo = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/getTeamInfo', data, { params });
  return response.data;
};

export const getFreePlayers = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/getFreePlayers', data, { params });
  return response.data;
};

export const addTeamPlayer = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/addTeamPlayer', data, { params });
  return response.data;
};

export const removeTeamPlayer = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/removePlayer', data, { params });
  return response.data;
};

export const changePosition = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/changePosition', data, { params });
  return response.data;
};

export const getPositions = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/getPositions', data, { params });
  return response.data;
};

export const createTeam = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/createTeam', data, { params });
  return response.data;
};

export const saveSettings = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/saveSettings', data, { params });
  return response.data;
};

export const getItems = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/game/items', data, { params });
  return response.data;
};

export const addEquip = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/game/equip', data, { params });
  return response.data;
};

export const getEquipment = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/game/equipment', data, { params });
  return response.data;
};

export const getSkills = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/nfts/getSkills', data, { params });
  return response.data;
};

export const setSkills = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/nfts/setSkills', data, { params });
  return response.data;
};

export const createMatch = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/match/create', data, { params });
  return response.data;
};

export const claimYoungPlayers = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/young-player/claim', data, { params });
  return response.data;
};

export const joinMatch = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/match/join', data, { params });
  return response.data;
};

export const getMatchDetail = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/match/detail', data, { params });
  return response.data;
};

export const getMatchReport = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/match/report', data, { params });
  return response.data;
};

export const saveLogo = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/team/saveLogo', data, { params });
  return response.data;
};

export const getVerifyCode = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/auth/verify', data, { params });
  return response.data;
};

export const loginWithEmail = async ({ data, params }) => {
  const response = await axiosInstance.post('/api/auth/login', data, { params });
  return response.data;
};
export const logoutRequest = async () => {
  const response = await axiosInstance.post('/api/auth/logout');
  return response.data;
};
